import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/img/tecnico.png'
import _imports_1 from '@/assets/img/plus_icon.svg'
import _imports_2 from '@/assets/img/minus_icon.svg'
import _imports_3 from '@/assets/img/building_active.png'
import _imports_4 from '@/assets/img/tecnico_active.png'


const _hoisted_1 = { class: "accordionContainer" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { src: _imports_1 }
const _hoisted_5 = { src: _imports_2 }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "accordionContainer" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_10 = { src: _imports_1 }
const _hoisted_11 = { src: _imports_2 }
const _hoisted_12 = { class: "filter" }
const _hoisted_13 = { class: "filter" }
const _hoisted_14 = { class: "mt-5" }
const _hoisted_15 = { class: "d-flex align-items-center mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_technicians_images = _resolveComponent("technicians-images")!
  const _component_toggle = _resolveComponent("toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tecniciCollapse = !_ctx.tecniciCollapse))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_localized_text, {
            localizedKey: "Tecnici",
            text: "Tecnici"
          })
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
          [_vShow, !_ctx.tecniciCollapse]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
          [_vShow, _ctx.tecniciCollapse]
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["body", {'opened': _ctx.tecniciCollapse}]),
        style: _normalizeStyle(_ctx.tecniciCollapse ? 'height: 527px;' : 'height: 0px')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tecniciRoles, (role, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_technicians_images, { role: role }, null, 8, ["role"]),
              _createVNode(_component_localized_text, {
                localizedKey: role.toLowerCase(),
                text: role.toLowerCase(),
                class: "text-capitalize"
              }, null, 8, ["localizedKey", "text"])
            ]),
            _createVNode(_component_toggle, {
              modelValue: _ctx.checkIfActive(role),
              "onUpdate:modelValue": ($event: any) => (_ctx.toggleTech($event, role))
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      ], 6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "header",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buildingCollapse = !_ctx.buildingCollapse))
      }, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_localized_text, {
            localizedKey: "Building",
            text: "Building"
          })
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
          [_vShow, !_ctx.buildingCollapse]
        ]),
        _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
          [_vShow, _ctx.buildingCollapse]
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["body", {'opened': _ctx.buildingCollapse}]),
        style: _normalizeStyle(_ctx.buildingCollapse ? 'height: 96px;' : 'height: 0px')
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_localized_text, {
            localizedKey: "Ticket attivi",
            text: "Ticket attivi"
          }),
          _createVNode(_component_toggle, {
            modelValue: _ctx.buildingActiveToggle,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buildingActiveToggle) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_localized_text, {
            localizedKey: "Ticket non attivi",
            text: "Ticket non attivi"
          }),
          _createVNode(_component_toggle, {
            modelValue: _ctx.buildingNotActiveToggle,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buildingNotActiveToggle) = $event))
          }, null, 8, ["modelValue"])
        ])
      ], 6)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_localized_text, {
        localizedKey: "Legenda",
        text: "Legenda",
        class: "fs_14 fw_700 d-block mb-3"
      }),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_localized_text, {
          localizedKey: "In movimento",
          text: "In movimento",
          class: "fs_14 ms-2"
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_localized_text, {
          localizedKey: "Parcheggiato",
          text: "Parcheggiato",
          class: "fs_14 ms-2"
        })
      ])
    ])
  ]))
}